var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(_vm.url)}&show_text=false&width=360`,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }